import http from 'plugins/axios';

export default {
  getTasks(data) {
    return http.get({
      url: '/la/admin/sms/send/user',
      data
    });
  }
  // createTask(data) {
  //   return http.post({
  //     url: '/la/admin/sms/add',
  //     data
  //   });
  // },
  // updateTask(data) {
  //   return http.post({
  //     url: '/la/admin/sms/update',
  //     data
  //   });
  // }
};
